import React from 'react';
import { GLOBAL } from '../../App';

import {ReactComponent as schedule} from '../../assets/schedule.svg';
import {ReactComponent as schedule_small} from '../../assets/schedule_small.svg';
import { mergeClassNames } from '../../utils/mergeClassNames';

const SVGs = {
	schedule,
	schedule_small,
}

interface LinkedSVGProps {
	name:string,
	links:any,
}

export class LinkedSVG extends React.Component<LinkedSVGProps>
{

	private _svg:HTMLElement;
	componentDidMount()
	{
		if(!this._svg) return;
		Object.entries(this.props.links).forEach(([k, v]) => {

			this._svg.querySelectorAll(`#${k}`).forEach((e) => {
				if(e.parentElement?.tagName?.toLowerCase() != 'a')
				{
					let a = document.createElementNS(this._svg.namespaceURI, 'a');
					a.setAttribute('href', GLOBAL.router.normalize(v as string));
					e.parentElement.replaceChild(a, e);
					a.appendChild(e);
				}
			});
		});
	}

	render()
	{
		let C = SVGs[this.props.name];
		return (
			<>
				{C?(<C ref={r => this._svg = r} className={'nofill'}></C>):null}
			</>
		)
	}
}